import { forwardRef, useImperativeHandle } from 'react';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { useControl, ControlPosition } from 'react-map-gl';

//https://github.com/visgl/react-map-gl/blob/master/examples/draw-polygon/src/draw-control.ts

type DrawControlProps = ConstructorParameters<typeof MapboxDraw>[0] & {
  position?: ControlPosition;

  onCreate?: (evt: { features: object[] }) => void;
  onUpdate?: (evt: { features: object[]; action: string }) => void;
  onDelete?: (evt: { features: object[] }) => void;
  onModeChange?: (evt: { mode: string }) => void;
};

// eslint-disable-next-line react/display-name
export const DrawControl = forwardRef((props: DrawControlProps, ref) => {
  const drawRef: MapboxDraw = useControl<MapboxDraw>(
    () => new MapboxDraw(props),
    ({ map }) => {
      if (props.onCreate) map.on('draw.create', props.onCreate);
      if (props.onUpdate) map.on('draw.update', props.onUpdate);
      if (props.onDelete) map.on('draw.delete', props.onDelete);
      if (props.onModeChange) map.on('draw.modechange', props.onModeChange);
    },
    ({ map }) => {
      if (props.onCreate) map.off('draw.create', props.onCreate);
      if (props.onUpdate) map.off('draw.update', props.onUpdate);
      if (props.onDelete) map.off('draw.delete', props.onDelete);
      if (props.onModeChange) map.off('draw.modechange', props.onModeChange);
    },
    {
      position: props.position,
    },
  );

  useImperativeHandle(ref, () => drawRef, [drawRef]);

  return null;
});
